import { render, staticRenderFns } from "./IPNTable.vue?vue&type=template&id=72fd0510&"
import script from "./IPNTable.vue?vue&type=script&lang=js&"
export * from "./IPNTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports